import { render, staticRenderFns } from "./InsertToSystemPrompt.vue?vue&type=template&id=5c016d74"
import script from "./InsertToSystemPrompt.vue?vue&type=script&lang=js"
export * from "./InsertToSystemPrompt.vue?vue&type=script&lang=js"
import style0 from "./InsertToSystemPrompt.vue?vue&type=style&index=0&id=5c016d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports